// Reference to the store to use it outide actions
let store = null;
let dispatch = null;

const initStoreHelper = (storeParam) => {
    if (!store && !dispatch) {
        store = storeParam;
        dispatch = storeParam.dispatch;
    }
}

const getStore = () => store;

const getDispatch = () => dispatch;

export {
    initStoreHelper,
    getStore,
    getDispatch
}